<template>
  <div class="min-w-[200px]">
    <p class="mb-[4px] px-[8px] text-[#828282] text-[10px]">
      {{ label }}
    </p>
    <div
      v-if="options.length > 0"
      class="h-[150px] overflow-y-auto"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="flex items-center gap-[8px] p-[8px]"
      >
        <b-form-checkbox
          v-model="checkedOptions"
          :disabled="option.disabled"
          :value="option.value"
        />
        <span
          :class="{ 'text-[#828282]': option.disabled }"
        >
          {{ option.label }}
        </span>
      </div>
      <slot name="footer" />
    </div>
    <div
      v-else
      class="h-[100px] flex items-center justify-center"
    >
      <p class="text-center">
        {{ emptyText }}
      </p>
    </div>
    <div
      v-if="options.length > 0"
      class="flex items-center gap-[8px] flex-wrap"
    >
      <b-button
        variant="outline-primary"
        size="sm"
        @click="reset"
      >
        Reset
      </b-button>
      <b-button
        class="flex-1"
        variant="primary"
        size="sm"
        @click="apply"
      >
        Terapkan
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownSubItem',
  props: {
    label: {
      type: String,
      default: 'Pilih Data',
    },
    options: {
      type: Array,
      default: () => [],
    },
    selectedOptions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkedOptions: [...(this.selectedOptions || [])],
    }
  },
  computed: {
    emptyText() {
      if (this.loading) {
        return 'Memuat data...'
      }
      return 'Tidak ada opsi'
    },
  },
  watch: {
    selectedOptions: {
      handler(newVal) {
        this.checkedOptions = [...(newVal || [])]
      },
      immediate: true,
    },
  },
  methods: {
    apply() {
      this.$emit('on-apply', this.checkedOptions)
    },
    reset() {
      this.checkedOptions = []
      this.$emit('on-apply', [])
    },
  },
}
</script>
